// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/image/logo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #F1F1F1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: rgb(133, 112, 112);
}

button {
  box-shadow: none !important;
}

.login-form-logo {
  z-index: 3;
  position: relative;
  top: 60px;
  left: 0;
  right: 0;
  width: 510px;
  height: 100px;
  margin: auto;
  background: #F5FAFF 0% 0% no-repeat padding-box;
  padding: 20px 0px;
  border-radius: 10px 10px 0px 0px;
  opacity: 1;
  box-shadow: 5px 10px 10px #00000029;
}

.login-form {
  transform-style: preserve-3d;
  background-color: white;
  z-index: 2;
  position: fixed;
  top: 160px;
  left: 0;
  right: 0;
  width: 470px;
  margin: auto;
}

.login-form::before {
  content: "";
  position: absolute;
  top: 24px;
  left: -14px;
  background: #F5FAFF 0% 0% no-repeat padding-box;
  height: 30px;
  width: 30px;
  transform: translateZ(-10px) rotate(45deg)
}

.login-form::after {
  content: "";
  position: absolute;
  top: 24px;
  right: -14px;
  background: #F5FAFF 0% 0% no-repeat padding-box;
  height: 30px;
  width: 30px;
  transform: translateZ(-10px) rotate(45deg);
}

.login-form-bottom {
  width: 100%;
  height: 48px;
  background: #F5FAFF 0% 0% no-repeat padding-box;
  border-top: 1px solid #EBEBEB;
  opacity: 1;
  border-radius: 50% 50% 0 0;
}

.app-modal-body-overflow .ant-modal-body,
.app-modal-without-footer-body-overflow .ant-modal-body {
  max-height: calc(100vh - 200px) !important;
  display: flex;
  flex-direction: column;
  overflow: auto !important;
  padding-left: 10px!important;
  padding-right: 10px!important;
}

.app-modal-without-footer-body-overflow .ant-modal-body {
  max-height: calc(100vh - 100px) !important;
}

.ant-modal-fullscreen {
  width: 100vw !important;
  height: 100vh;
  top: 0px !important;
  max-width: none !important;
  margin: 0 !important;
}

.ant-modal-fullscreen .ant-modal-body {
  height: calc(100vh - 110px) !important;
  display: flex;
  flex-direction: column;
  overflow: auto !important;
  padding-left: 10px!important;
  padding-right: 10px!important;
}

.ant-modal-fullscreen .ant-modal-content {
  height: 100vh;
  width: 100vw;
}

.ant-tabs-nav {
  margin-bottom: 4px !important;
}


.ant-message .anticon {
  top: -3px !important;
}

.ant-pagination {
  display: inline-flex;
}

.main-content .ant-card-small>.ant-card-body:first-child {
  padding-top: 0px;
}

.ant-col .ant-form-item {
  margin-bottom: 10px;
}

.ant-col.ant-form-item-label {
  padding: 0px !important;
}

/* Loader Page CSS Starts */

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Loader Page CSS Ends */
.tox-notification.tox-notification--in.tox-notification--warning,
.tox-statusbar__branding {
  display: none !important;
}

.cp {
  cursor: pointer;
}

.ant-message .anticon {
  position: static !important;
}

.upload-w210-h210 .ant-upload.ant-upload-select {
  width: 209px !important;
  height: 200px !important;
  background-color: #F5FAFF !important;
}

.upload-w210-h110 .ant-upload.ant-upload-select {
  width: 429px !important;
  height: 200px !important;
  background-color: #F5FAFF !important;
}

.my-img {
  animation: rotateImg 2s linear infinite;

}

@keyframes rotateImg {
  from {
    transform: rotate(359deg);
  }

  to {
    transform: rotate(0deg);
  }
}


.ppp {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
  transform: scale3d(1, 1, 1);
  cursor: grab;
  transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: auto;
}

.layout1 {
  background: white !important;
  color: black !important;
}

.my-img-two {
  animation: rotateImgs 0.7s linear infinite;
}

.bannerImg {
  position: absolute;
  height: 350px;
  right: 25px;
  left: 275px;
}

.bannerImg img {
  width: 100%;
  background: #fff;
  object-fit: cover;
  height: 100%;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
}

:where(.css-dev-only-do-not-override-1sya4zs).ant-input-search>.ant-input-group>.ant-input-group-addon:last-child .ant-input-search-button {
  background-color: red;
  border-radius: 0 5px 5px 0;
}

.appLogo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  object-fit: cover;
  width: 200px;

  height: 100%;
  object-fit: cover;
}

@keyframes rotateImgs {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.table-row-border-none .ant-table-cell {
  border-top-width: 0px !important;
}

.ant-table-row-selected,
.ant-table-row-selected td,
.ant-table-row-selected td *{
  color: white !important;
}



.home-page-search-dropdown {
  text-align: left;
  border: black ridge 1px;
  border-radius: 10px;
  margin: 3px;
  width: 20rem;
  padding-left: 10px;
  position: absolute;
  top: 55px;
  z-index: 1000;
  background: white;

}


.ant-menu-vertical {
  background: "#ff6a02" !important;
}



.slick-dots,
.slick-dots-bottom {

  inset-inline-start: 1 !important;

  max-width: 125px !important;
  padding: 8px !important;
  background: #111199 !important;
  border-radius: 15px !important;

}

.ant-carousel .slick-dots li {
  margin-inline: 5px !important;
  inset-inline-end: 1 !important;
}

.ant-carousel .slick-dots {
  inset-inline-end: 1 !important;
  inset-inline-start: 0 !important;
}

/* .ant-carousel .slick-dots li button{
  width: 7px!important;
  height: 7px!important;
  border-radius: 50%;
} */



.proPrice {
  position: absolute;
  /* height: 44px; */
  background: red;
  top: -7px;
  padding-right: -13px;
  /* width: 100%; */
  width: 100%;
  min-height: 45px;
  clip-path: polygon(11% 0, 0 100%, 100% 100%, 100% 0%, 75% 0);
}

:where(.css-dev-only-do-not-override-1l1fjhg).ant-btn-default {
  background: transparent !important;
  border: none !important;
}

:where(.css-dev-only-do-not-override-1l1fjhg).ant-btn.ant-btn-icon-only>span.anticon-upload {
  transform: scale(2.5);
  color: #C4CFDA;
}

.wrapper.ant-upload-picture-card-wrapper .ant-upload.ant-upload-select {
  background-color: #F5FAFF;
}

.ant-upload.ant-upload-select{
  width: 100%;
}

 /* input fields effect  */
 .ant-input {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.ant-input:focus {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transform: scale(1.01);
}

.ant-input:focus-visible {
  outline: none; /* Optionally remove the outline for focused elements */
}
 


@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spin2 {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}




/* :where(.css-dev-only-do-not-override-1x39qhy).ant-layout .ant-layout-sider{
  background-color: #0CAC66 !important;
}  */

/* :where(.css-dev-only-do-not-override-1x39qhy).ant-layout .ant-layout-sider{
  background-color: #FF7518 !important;
} */

/* :where(.css-dev-only-do-not-override-1x39qhy) a{
  color: white !important;
} */

/* :where(.css-dev-only-do-not-override-1f8sbuu) a{
  color: white !important;
} */

.tox-notifications-container{
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,+CAA+C;EAC/C,iBAAiB;EACjB,gCAAgC;EAChC,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,UAAU;EACV,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,+CAA+C;EAC/C,YAAY;EACZ,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,+CAA+C;EAC/C,YAAY;EACZ,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,6BAA6B;EAC7B,UAAU;EACV,0BAA0B;AAC5B;;AAEA;;EAEE,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;;AAW3B;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,yBAAyB;AACzB;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;;AAEzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;AACF;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,iEAAiE;EACjE,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,uFAAuF;AACzF;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,yDAAiD;EACjD,iBAAiB;EACjB,YAAY;;EAEZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,uBAAuB;AACzB;;;;AAIA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,iBAAiB;;AAEnB;;;AAGA;EACE,gCAAgC;AAClC;;;;AAIA;;;EAGE,gCAAgC;;EAEhC,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;;AAEhC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;;;GAIG;;;;AAIH;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAEhB,4DAA4D;AAC9D;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;CAEC,yBAAyB;CACzB;EACC,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,aAAa,EAAE,uDAAuD;AACxE;;;;AAIA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF;;;;;AAKA;;IAEI;;AAEJ;;GAEG;;AAEH;;GAEG;;AAEH;;GAEG;;AAEH;EACE,wBAAwB;AAC1B","sourcesContent":["::-webkit-scrollbar {\n  width: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #F1F1F1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgb(133, 112, 112);\n}\n\nbutton {\n  box-shadow: none !important;\n}\n\n.login-form-logo {\n  z-index: 3;\n  position: relative;\n  top: 60px;\n  left: 0;\n  right: 0;\n  width: 510px;\n  height: 100px;\n  margin: auto;\n  background: #F5FAFF 0% 0% no-repeat padding-box;\n  padding: 20px 0px;\n  border-radius: 10px 10px 0px 0px;\n  opacity: 1;\n  box-shadow: 5px 10px 10px #00000029;\n}\n\n.login-form {\n  transform-style: preserve-3d;\n  background-color: white;\n  z-index: 2;\n  position: fixed;\n  top: 160px;\n  left: 0;\n  right: 0;\n  width: 470px;\n  margin: auto;\n}\n\n.login-form::before {\n  content: \"\";\n  position: absolute;\n  top: 24px;\n  left: -14px;\n  background: #F5FAFF 0% 0% no-repeat padding-box;\n  height: 30px;\n  width: 30px;\n  transform: translateZ(-10px) rotate(45deg)\n}\n\n.login-form::after {\n  content: \"\";\n  position: absolute;\n  top: 24px;\n  right: -14px;\n  background: #F5FAFF 0% 0% no-repeat padding-box;\n  height: 30px;\n  width: 30px;\n  transform: translateZ(-10px) rotate(45deg);\n}\n\n.login-form-bottom {\n  width: 100%;\n  height: 48px;\n  background: #F5FAFF 0% 0% no-repeat padding-box;\n  border-top: 1px solid #EBEBEB;\n  opacity: 1;\n  border-radius: 50% 50% 0 0;\n}\n\n.app-modal-body-overflow .ant-modal-body,\n.app-modal-without-footer-body-overflow .ant-modal-body {\n  max-height: calc(100vh - 200px) !important;\n  display: flex;\n  flex-direction: column;\n  overflow: auto !important;\n  padding-left: 10px!important;\n  padding-right: 10px!important;\n}\n\n.app-modal-without-footer-body-overflow .ant-modal-body {\n  max-height: calc(100vh - 100px) !important;\n}\n\n.ant-modal-fullscreen {\n  width: 100vw !important;\n  height: 100vh;\n  top: 0px !important;\n  max-width: none !important;\n  margin: 0 !important;\n}\n\n.ant-modal-fullscreen .ant-modal-body {\n  height: calc(100vh - 110px) !important;\n  display: flex;\n  flex-direction: column;\n  overflow: auto !important;\n  padding-left: 10px!important;\n  padding-right: 10px!important;\n}\n\n.ant-modal-fullscreen .ant-modal-content {\n  height: 100vh;\n  width: 100vw;\n}\n\n.ant-tabs-nav {\n  margin-bottom: 4px !important;\n}\n\n\n.ant-message .anticon {\n  top: -3px !important;\n}\n\n.ant-pagination {\n  display: inline-flex;\n}\n\n.main-content .ant-card-small>.ant-card-body:first-child {\n  padding-top: 0px;\n}\n\n.ant-col .ant-form-item {\n  margin-bottom: 10px;\n}\n\n.ant-col.ant-form-item-label {\n  padding: 0px !important;\n}\n\n/* Loader Page CSS Starts */\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Loader Page CSS Ends */\n.tox-notification.tox-notification--in.tox-notification--warning,\n.tox-statusbar__branding {\n  display: none !important;\n}\n\n.cp {\n  cursor: pointer;\n}\n\n.ant-message .anticon {\n  position: static !important;\n}\n\n.upload-w210-h210 .ant-upload.ant-upload-select {\n  width: 209px !important;\n  height: 200px !important;\n  background-color: #F5FAFF !important;\n}\n\n.upload-w210-h110 .ant-upload.ant-upload-select {\n  width: 429px !important;\n  height: 200px !important;\n  background-color: #F5FAFF !important;\n}\n\n.my-img {\n  animation: rotateImg 2s linear infinite;\n\n}\n\n@keyframes rotateImg {\n  from {\n    transform: rotate(359deg);\n  }\n\n  to {\n    transform: rotate(0deg);\n  }\n}\n\n\n.ppp {\n  max-width: 100%;\n  max-height: 100%;\n  vertical-align: middle;\n  transform: scale3d(1, 1, 1);\n  cursor: grab;\n  transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n  user-select: none;\n  pointer-events: auto;\n}\n\n.layout1 {\n  background: white !important;\n  color: black !important;\n}\n\n.my-img-two {\n  animation: rotateImgs 0.7s linear infinite;\n}\n\n.bannerImg {\n  position: absolute;\n  height: 350px;\n  right: 25px;\n  left: 275px;\n}\n\n.bannerImg img {\n  width: 100%;\n  background: #fff;\n  object-fit: cover;\n  height: 100%;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;\n}\n\n:where(.css-dev-only-do-not-override-1sya4zs).ant-input-search>.ant-input-group>.ant-input-group-addon:last-child .ant-input-search-button {\n  background-color: red;\n  border-radius: 0 5px 5px 0;\n}\n\n.appLogo {\n  background-image: url(\"../public/image/logo.svg\");\n  object-fit: cover;\n  width: 200px;\n\n  height: 100%;\n  object-fit: cover;\n}\n\n@keyframes rotateImgs {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.table-row-border-none .ant-table-cell {\n  border-top-width: 0px !important;\n}\n\n.ant-table-row-selected,\n.ant-table-row-selected td,\n.ant-table-row-selected td *{\n  color: white !important;\n}\n\n\n\n.home-page-search-dropdown {\n  text-align: left;\n  border: black ridge 1px;\n  border-radius: 10px;\n  margin: 3px;\n  width: 20rem;\n  padding-left: 10px;\n  position: absolute;\n  top: 55px;\n  z-index: 1000;\n  background: white;\n\n}\n\n\n.ant-menu-vertical {\n  background: \"#ff6a02\" !important;\n}\n\n\n\n.slick-dots,\n.slick-dots-bottom {\n\n  inset-inline-start: 1 !important;\n\n  max-width: 125px !important;\n  padding: 8px !important;\n  background: #111199 !important;\n  border-radius: 15px !important;\n\n}\n\n.ant-carousel .slick-dots li {\n  margin-inline: 5px !important;\n  inset-inline-end: 1 !important;\n}\n\n.ant-carousel .slick-dots {\n  inset-inline-end: 1 !important;\n  inset-inline-start: 0 !important;\n}\n\n/* .ant-carousel .slick-dots li button{\n  width: 7px!important;\n  height: 7px!important;\n  border-radius: 50%;\n} */\n\n\n\n.proPrice {\n  position: absolute;\n  /* height: 44px; */\n  background: red;\n  top: -7px;\n  padding-right: -13px;\n  /* width: 100%; */\n  width: 100%;\n  min-height: 45px;\n  -webkit-clip-path: polygon(0 100%, 0 100%, 100% 100%, 100% 0%, 9% 0);\n  clip-path: polygon(11% 0, 0 100%, 100% 100%, 100% 0%, 75% 0);\n}\n\n:where(.css-dev-only-do-not-override-1l1fjhg).ant-btn-default {\n  background: transparent !important;\n  border: none !important;\n}\n\n:where(.css-dev-only-do-not-override-1l1fjhg).ant-btn.ant-btn-icon-only>span.anticon-upload {\n  transform: scale(2.5);\n  color: #C4CFDA;\n}\n\n.wrapper.ant-upload-picture-card-wrapper .ant-upload.ant-upload-select {\n  background-color: #F5FAFF;\n}\n\n.ant-upload.ant-upload-select{\n  width: 100%;\n}\n\n /* input fields effect  */\n .ant-input {\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  cursor: pointer;\n}\n\n.ant-input:focus {\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transform: scale(1.01);\n}\n\n.ant-input:focus-visible {\n  outline: none; /* Optionally remove the outline for focused elements */\n}\n \n\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes spin2 {\n  0% {\n    transform: rotate(360deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n\n\n\n/* :where(.css-dev-only-do-not-override-1x39qhy).ant-layout .ant-layout-sider{\n  background-color: #0CAC66 !important;\n}  */\n\n/* :where(.css-dev-only-do-not-override-1x39qhy).ant-layout .ant-layout-sider{\n  background-color: #FF7518 !important;\n} */\n\n/* :where(.css-dev-only-do-not-override-1x39qhy) a{\n  color: white !important;\n} */\n\n/* :where(.css-dev-only-do-not-override-1f8sbuu) a{\n  color: white !important;\n} */\n\n.tox-notifications-container{\n  display: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
